<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m">
					{{ $t('rtr_personal-how-offline_kiosk.title1') }}<br />
					{{ $t('rtr_personal-how-offline_kiosk.title2') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-how-offline_kiosk.text1') }}<br />{{
						$t('rtr_personal-how-offline_kiosk.text2')
					}}<br />{{ $t('rtr_personal-how-offline_kiosk.text3') }}
				</p>
				<div class="button_area">
					<button
						class="button_bg_red mr_10"
						@click="$router.push({ name: 'auth-register' })"
					>
						{{ $t('button.signup') }}
					</button>
					<button
						class="button_bg_black"
						@click="$router.push({ name: 'auth-login' })"
					>
						{{ $t('auth.login_btn') }}
					</button>
				</div>
			</div>
		</div>

		<section class="content_area bg_gray">
			<p class="title_m">
				<span class="fc_red">{{
					$t('rtr_personal-how-offline_kiosk.text4')
				}}</span
				>{{ $t('rtr_personal-how-offline_kiosk.text5') }}
			</p>
			<div>
				<swiper
					:slides-per-view="1"
					:pagination="true"
					:navigation="true"
					:modules="modules"
				>
					<swiper-slide>
						<div class="slide_item">
							<div class="icon">
								<img
									src="@/assets/images/sub/m_offline_kiosk_icon_01.png"
									alt=""
								/>
							</div>
							<p class="body_m">
								{{ $t('rtr_personal-how-offline_kiosk.text6') }}<br />
								{{ $t('rtr_personal-how-offline_kiosk.text7') }}
							</p>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="slide_item">
							<div class="icon">
								<img
									src="@/assets/images/sub/m_offline_kiosk_icon_02.png"
									alt=""
								/>
							</div>
							<p class="body_m">
								{{ $t('rtr_personal-how-offline_kiosk.text8') }}<br />
								{{ $t('rtr_personal-how-offline_kiosk.text9') }}
							</p>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="slide_item">
							<div class="icon">
								<img
									src="@/assets/images/sub/m_offline_kiosk_icon_03.png"
									alt=""
								/>
							</div>
							<p class="body_m">
								{{ $t('rtr_personal-how-offline_kiosk.text10') }}<br />
								{{ $t('rtr_personal-how-offline_kiosk.text11') }}
							</p>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</section>
		<section>
			<div class="content_area type_2 bg_gray1">
				<p class="title_m">
					{{ $t('rtr_personal-how-offline_kiosk.text12') }}<br />
					{{ $t('rtr_personal-how-offline_kiosk.text13') }}
				</p>
				<div>
					<swiper :centered-slides="true" :slides-per-view="1.5">
						<swiper-slide>
							<div class="rectangle_w">
								<div>
									<div>
										<img
											src="@/assets/images/sub/offline_kiosk_rectangle_01.png"
											alt=""
											class="mb_20"
										/>
									</div>
									<p class="title_s">
										{{ $t('rtr_personal-how-offline_kiosk.text14') }}
									</p>
									<p class="body_m">
										{{ $t('rtr_personal-how-offline_kiosk.text15') }}
									</p>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="rectangle_w">
								<div>
									<div>
										<img
											src="@/assets/images/sub/offline_kiosk_rectangle_02.png"
											alt=""
											class="mb_20"
										/>
									</div>
									<p class="title_s">
										{{ $t('rtr_personal-how-offline_kiosk.text16') }}
									</p>
									<p class="body_m">
										{{ $t('rtr_personal-how-offline_kiosk.text17') }}
									</p>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<div class="rectangle_w">
								<div>
									<div>
										<img
											src="@/assets/images/sub/offline_kiosk_rectangle_03.png"
											alt=""
											class="mb_20"
										/>
									</div>
									<p class="title_s">
										{{ $t('rtr_personal-how-offline_kiosk.text18') }}
									</p>
									<p class="body_m">
										{{ $t('rtr_personal-how-offline_kiosk.text19') }}
									</p>
								</div>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</section>

		<section>
			<div class="content_area">
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_personal-how-offline_kiosk.title3') }}<br />{{
								$t('rtr_personal-how-offline_kiosk.title4')
							}}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/offline_kiosk_02.png" alt="" />
						</div>
						<p class="body_m">
							{{ $t('rtr_personal-how-offline_kiosk.text20') }}<br />
							{{ $t('rtr_personal-how-offline_kiosk.text21') }}
						</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
import { Pagination, Navigation } from 'swiper';
export default {
	name: 'OfflineKiosk.m',
	setup() {
		return {
			modules: [Pagination, Navigation],
		};
	},
};
</script>
<style scoped></style>
